export default "__VITE_PUBLIC_ASSET__f25fc556__"